import React, { PropsWithChildren } from 'react'
import ReactDOM from 'react-dom'

import './index.scss'

interface ModalPortalProps {
    isOpen: boolean
    onClose?(): void
}

const ModalPortal = (props: PropsWithChildren<ModalPortalProps>) => {
    const { isOpen, children, onClose } = props

    const doClose = () => {
        onClose && onClose()
    }

    const modalRoot = document.getElementById('modal-root')

    if (!modalRoot) {
        return null
    }

    return ReactDOM.createPortal(
        <>
            {isOpen && (
                <div className="modal-portal-wrapper">
                    <div className="overlay" onClick={doClose} />
                    {children}
                </div>
            )}
        </>,
        modalRoot
    )
}

export default ModalPortal
